<!-- Path: libs/components/modal/src/lib/ui-modal-mascot/ui-modal-mascot.component.html -->
<div
  class="ui-modal-mascot"
  [class.is-blinking]="blinking()"
  [attr.data-mood]="mood()"
  aria-hidden="true"
  (click)="react('happy')"
>
  <img
    class="ui-modal-mascot__image"
    [src]="src()"
    [alt]="alt()"
    width="168"
    height="168"
    loading="lazy"
    decoding="async"
  />

  <span class="ui-modal-mascot__eye ui-modal-mascot__eye--left" data-eye>
    <span class="ui-modal-mascot__pupil" data-pupil></span>
    <span class="ui-modal-mascot__eyelid"></span>
  </span>

  <span class="ui-modal-mascot__eye ui-modal-mascot__eye--right" data-eye>
    <span class="ui-modal-mascot__pupil" data-pupil></span>
    <span class="ui-modal-mascot__eyelid"></span>
  </span>

  <span
    class="ui-modal-mascot__mood-bubble"
    [class.is-visible]="bubbleVisible()"
  >
    {{ bubbleEmoji() }}
  </span>
</div>